export const ADMIN_USER_MODAL = 'ADMIN_USER_MODAL';
export const ADMIN_ROLES_MODAL = 'ADMIN_ROLES_MODAL';

export const setAdminUserModal = (state) => (dispatch) => {
    dispatch({ type: ADMIN_USER_MODAL, state });
};

export const setAdminRolesModal = (state) => (dispatch) => {
    dispatch({ type: ADMIN_ROLES_MODAL, state });
};

export default {
    ADMIN_USER_MODAL,
    ADMIN_ROLES_MODAL,
    setAdminUserModal,
    setAdminRolesModal,
};
